module.exports = __webpack_public_path__ + "post-listing-cross-promotoe-ico-1@2x-Y4mu5C9.png";